export var dimension = {
    height: {
        /** 64px */
        primaryNav: '64px',
        /** 48px */
        secondaryNav: '48px'
    },
    maxWidth: {
        /** 1440px */
        mainContent: '1440px'
    }
};
//# sourceMappingURL=dimension.js.map